import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const IpResponseSchema = z
  .object({
    data: z.object({
      ip: z.string(),
      city: z.string(),
      region: z.string(),
      region_code: z.string(),
      country: z.string(),
      country_name: z.string(),
      continent_code: z.string(),
      in_eu: z.boolean(),
      postal: z.string(),
      latitude: z.number(),
      longitude: z.number(),
      timezone: z.string(),
      utc_offset: z.string(),
      country_calling_code: z.string(),
      currency: z.string(),
      languages: z.string(),
      asn: z.string(),
      org: z.string(),
    }),
  })
  .transform((data) => transformKeysToCamelCase(data));

export type TIpDataResponse = z.infer<typeof IpResponseSchema>;
export type TIpData = TIpDataResponse['data'];
